import { useEffect, useState } from "react";
import { api, unwrap } from "@/lib/api";
import { useSettings } from "@/contexts/SettingsContext";

/**
 * Sidebar block showing per-stylist commission earned today / this week / this month.
 * Polls every 10s.
 */
export function MyCommissionBox({ staffId }) {
  const { settings } = useSettings();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!staffId) return;
    let active = true;
    const fetchOnce = async () => {
      try {
        const r = await api.get(`/staff/${staffId}/commission`);
        if (active) setData(unwrap(r));
      } catch {}
    };
    fetchOnce();
    const i = setInterval(fetchOnce, 10000);
    return () => { active = false; clearInterval(i); };
  }, [staffId]);

  if (!data) return null;
  const c = settings.currency || "₹";

  return (
    <div className="glass-primary rounded-[20px] p-5" data-testid="stylist-my-commission-box">
      <div className="overline mb-3">My commission</div>
      <div className="space-y-2">
        <Row label="Today" value={`${c}${(data.today?.commission || 0).toLocaleString("en-IN")}`} accent="#8E6A1A" />
        <Row label="This week" value={`${c}${(data.week?.commission || 0).toLocaleString("en-IN")}`} accent="#5E4060" />
        <Row label="This month" value={`${c}${(data.month?.commission || 0).toLocaleString("en-IN")}`} accent="#15803D" big />
      </div>
      <div className="mt-3 pt-3 border-t border-white/40 font-inter text-[11px] text-[var(--color-text-muted)]">
        Rate · {data.commission_rate}% · {data.month?.clients || 0} clients this month
      </div>
    </div>
  );
}

function Row({ label, value, accent, big }) {
  return (
    <div className="flex items-center justify-between">
      <span className="font-inter text-[12.5px] text-[var(--color-text-secondary)]">{label}</span>
      <span className="font-mono leading-none" style={{ fontSize: big ? 22 : 16, color: accent }}>{value}</span>
    </div>
  );
}

export default MyCommissionBox;
